import { render, staticRenderFns } from "./ModalData.vue?vue&type=template&id=21e07850&scoped=true"
import script from "./ModalData.vue?vue&type=script&lang=js"
export * from "./ModalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e07850",
  null
  
)

export default component.exports